import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { ArrowLeft } from '@flipdish/ui-icons';
import { ButtonUtility } from '@flipdish/ui-library/components/atoms/UtilityButton';
import { SidePanel } from '@flipdish/ui-library/components/organisms/SidePanel';
import { getTranslate } from 'react-localize-redux';

import { OrgAndBrandSelectorContent } from '../../../../components/RMS/OrgAndBrandSelector/OrgAndBrandSelector';
import OrgCreateAdminBtn from '../../../../components/RMS/OrgAndBrandSelector/OrgCreateAdminBtn';

type Props = {
  /** Closes the panel after an org or brand is chosen. */
  onDone: () => void;
  /** Returns to the brand list. */
  onBack: () => void;
};

/** The org switcher as `SidePanel` content. */
export const SwitchOrganisationPanel = ({ onDone, onBack }: Props) => {
  const translate = useAppSelector((state) => getTranslate(state.locale));

  return (
    <>
      <SidePanel.Header className="flex items-center gap-2">
        <ButtonUtility
          icon={ArrowLeft}
          tooltip={translate('Back') as string}
          color="tertiary"
          size="sm"
          onClick={onBack}
          data-testid="fd-side-panel--back"
        />
        <h2 className="truncate pr-12 text-lg font-semibold text-primary">
          {translate('Switch_organisation') as string}
        </h2>
      </SidePanel.Header>
      <SidePanel.Content className="gap-0 px-0 lg:px-0" data-fd="switch-organisation-panel">
        <OrgAndBrandSelectorContent open toggleOrgDrawer={onDone} />
      </SidePanel.Content>
      <SidePanel.Footer className="p-0">
        <OrgCreateAdminBtn toggleOrgDrawer={onDone} />
      </SidePanel.Footer>
    </>
  );
};

export default SwitchOrganisationPanel;
